module.exports = __webpack_public_path__ + "img/product1.739b3716.png";